import React from 'react';
import type { Page } from '@reolink-web/bff-framework-press/client';
import { hydrateRoot } from 'react-dom/client';
import CompHeader from './render-header';
import $SharedEntry from './+Shared';
import type { IGlobalAppContext } from '@/shared/globalAppContext';
import { globalAppContext } from '@/shared/globalAppContext';

const clientModule = {
    async onRenderClient(ctx, props) {
        const isomorphicProps = await $SharedEntry.onRenderIsomorphic(ctx, props);
        hydrateRoot(
            document.getElementById('header')!,
            <React.StrictMode>
                <globalAppContext.Provider value={ ctx as IGlobalAppContext }>
                    <CompHeader ctx={ isomorphicProps }></CompHeader>
                </globalAppContext.Provider>
            </React.StrictMode>,
        );
    },
} satisfies Page.IPageClientModule<unknown>;

export default clientModule;
